export default __webpack_public_path__ + "static/media/spark_36.9043dddf.png";